const actions = {
  LIST_EMPRESAS: 'LIST_EMPRESAS',
  LIST_EMPRESAS_SELECTBOX: 'LIST_EMPRESAS_SELECTBOX',
  CREATE_EMPRESAS: 'CREATE_EMPRESAS',
  READ_EMPRESAS: 'READ_EMPRESAS',
  UPDATE_EMPRESAS: 'UPDATE_EMPRESAS',
  DELETE_EMPRESAS: 'DELETE_EMPRESAS',


  empresasList: data => {     
    return {
      type: actions.LIST_EMPRESAS,
      data,
    };
  },

  empresasListSelectBox: data => {
    return {
      type: actions.LIST_EMPRESAS_SELECTBOX,
      data,
    };
  },

  empresasCreate: data => {
    return {
      type: actions.CREATE_EMPRESAS,
      data,
    };
  },

  empresasRead: data => {
    return {
      type: actions.READ_EMPRESAS,
      data,
    };
  },

  empresasUpdate: data => {
    return {
      type: actions.UPDATE_EMPRESAS,
      data,
    };
  },

  empresasDelete: () => {
    return {
      type: actions.DELETE_EMPRESAS,      
    };
  },
};

export default actions;
